import React from 'react';
import ReactEcharts from 'echarts-for-react';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import { useTheme } from '../../../../theme-context';
import NoDataOverlay from '../components/NoDataLayer';

interface IPieData {
    name: string;
    value: number;
    show?: any;
}

interface IPieChart {
    data: IPieData[];
}

const PieChart = ({ data }: IPieChart) => {
    const { theme } = useTheme();
    const hasData = data?.some(d => d?.value > 0);

    const getOption = () => ({
        color: ['#10B981', '#F59E0B', '#EF4444', '#545863'],
        legend: {
            show: true,
            orient: 'vertical',
            right: 10,
            top: 'middle',
            icon: 'circle',
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 16,
            hoverLink: true,
            textStyle: { color: theme === 'dark' ? '#fff' : '#000', fontSize: 14 },
            formatter: (name: string) => {
                const item: any = (data && data.find?.((d) => d.name === name)) || {};
                return `${name}    ${item?.show ?? ''}${item?.value ?? 0}`;
            }
        },
        tooltip: { trigger: 'item', triggerOn: 'mousemove', formatter: '{b}: {d}%' },
        series: [
            {
                type: 'pie',
                radius: ['40%', '55%'],
                center: ['30%', '50%'],
                label: { show: false },
                labelLine: { show: false },
                data: data,
                itemStyle: { opacity: hasData ? 1 : 0.4 },
                emphasis: { focus: 'self', scale: true, scaleSize: 8 }
            }
        ]
    });

    // helpers that DON'T depend on local arrays
    const getDataIndexByName = (chart: any, seriesIndex: number, name: string) => {
        try {
            const opt = chart.getOption();
            const series = (opt.series && opt.series[seriesIndex]) || {};
            const arr = series.data || [];
            return arr.findIndex((it: any) => (it?.name ?? '') === name);
        } catch { return -1; }
    };

    const onEvents = {
        legendmouseover: (params: any, chart: any) => {
            const dataIndex = getDataIndexByName(chart, 0, params.name);
            if (dataIndex > -1) {
                chart.dispatchAction({ type: 'highlight', seriesIndex: 0, dataIndex });
                chart.dispatchAction({ type: 'showTip', seriesIndex: 0, dataIndex });
            }
        },
        legendmouseout: (_params: any, chart: any) => {
            chart.dispatchAction({ type: 'downplay', seriesIndex: 0 }); // clears any highlight
            chart.dispatchAction({ type: 'hideTip' });
        }
    };


    return (
        <div className="relative h-[400px] w-full">
            <ReactEcharts onEvents={onEvents} option={getOption()} style={{ height: 400, width: '100%' }} />
            {!hasData && <NoDataOverlay />}
        </div>
    );
};

export default PieChart;